import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom' //useNavigate

import { Sections } from './Sections'
import { Zones } from './Zones'

import { DeleteGameToShow, ShowSectionsView } from './../../utilities/BL/Dashboard'
import { DeleteSessionData } from './../../utilities/BL/Sessions'
import { WaitUntilConnected, ConnectWebSocket, DisconnectWebSocket, IsWomensModeActive, GetAutozoneState as BLGetAutozoneState } from './../../utilities/BL/Zones'
import { Loading } from '../Commons/Loading'


const Dashboard = () => {
    const [view, setView] = useState('loading')
    const [searchParams] = useSearchParams()
    const [connectionStatus, setConnectionStatus] = useState('idle') // 'idle', 'connecting', 'connected', 'reconnecting', 'error'
    const [toastMessage, setToastMessage] = useState('')

    const [isLoading, setIsLoading] = useState(true)


    const showToast = (msg) => {
        try {
            setToastMessage(msg)
            setTimeout(() => setToastMessage(''), 3000) // Se oculta tras 3 segundos    
        } catch (error) {
            
        }
    }

    const SetViewToShow = async () => {
        try {
            // 1) Consulta si autozona está activo
            const autoRes = await BLGetAutozoneState()
            const isAuto = autoRes?.success && !!autoRes?.data?.isAutozoneActive

            // 2) Si autozona: conectar directo SIN listado
            if (isAuto) {
                await DeleteGameToShow()       // como ya lo haces
                await DisconnectWebSocket()    // aseguras limpio

                // Conexión sin zona (el server asigna) + uid estable en la URL
                await ConnectWebSocket(null, setConnectionStatus, showToast)
                await WaitUntilConnected()

                // Tip: el server enviará {type:'assignedZone', data:{zone:'azul'|'oro'|...}}
                // y el BL guardará la zona en sesión vía SaveUserZone.
                setView('sections')
                return
            }

            // 3) Modo MANUAL (comportamiento actual)
            const urlParameter = searchParams.get(process.env.REACT_APP_URLPARAMETER)
            const response = await ShowSectionsView(urlParameter)

            if (response.success) {
                await DeleteGameToShow()

                const zone = response?.data
                if (!zone) {
                    await DeleteSessionData()
                    setView('zones')
                    return
                }

                const zoneName = zone?.text
                if (zoneName) {
                    await DisconnectWebSocket()
                    await ConnectWebSocket(zone.text, setConnectionStatus, showToast)
                    await WaitUntilConnected()
                    setView('sections')
                } else {
                    await DeleteSessionData()
                    setView('zones')
                }
            } else {
                await DeleteSessionData()
                setView('zones')
            }
        } catch (error) {
            await DeleteSessionData()
            setView('zones')
        }
    }

    const Logout = async () => {
        try {
            setIsLoading(true)
            
            await DeleteSessionData()
            await SetViewToShow()
        } catch (error) {
            
        } finally {
            setIsLoading(false)
        }
    }

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
            
            await SetViewToShow()
        } catch (error) {
            
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])

    useEffect(() => {
        return () => {
            DisconnectWebSocket()
        }
    }, [])


    return (
        isLoading ? (
            <Loading />
        ) : (
            <>
                <main className="container Dashboard Container-FullHeight">
                    <div className="row mt-5">
                        <button className="btn btn-outline-danger d-block w-auto ms-auto me-5 text-start" onClick={Logout}>
                            <i className="bi bi-box-arrow-left"></i>
                        </button>
                    </div>
    
                    <div className="row mt-4">
                        {/* <img src="/img/brand/logotipo-adsl.png" className="LogoADSL" alt="Logo" /> */}
                        <img src="/img/page/adsl-five-bicolor.png" className="LogoADSLxZtudia" alt="Logo" />
    
                        <div className="mt-5">
                            {view === 'loading' && <p>Cargando...</p>}
                            {view === 'zones' && <Zones onZoneSaved={() => setView('sections')} />}
                            {view === 'sections' && <Sections />}
                        </div>
                    </div>
                </main>
    
                <footer id='fdmFooter' className='container'>
                    <p className='text-center FdmFooter FooterCredits'>
                        <a href='https://interaktia.com/?utm_source=dashboard_web&utm_medium=footer&utm_campaign=fcm_doradosfc' target='_blank' className='text-dark'>Hecho con ♥ por Interaktia | 2026</a>
                    </p>
                </footer>
    
                {toastMessage && (
                    <div className="toast-container position-fixed bottom-0 start-50 translate-middle-x mb-3">
                        <div className="toast show bg-success text-white px-3 py-2 shadow rounded">
                            {toastMessage}
                        </div>
                    </div>
                )}
            </>
        )
    )
}

export { Dashboard };